import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";
import { LeftTabData } from "../../../../Data/UiKits/Tabs";

const MaterialContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {LeftTabData &&
        LeftTabData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            {item.text}
          </TabPane>
        ))}
    </TabContent>
  );
};
export default MaterialContent;
